<template>
    <multiselect
        v-model="commonAgreement"
        :options="agreements"
        track-by="uuid"
        label="name"
        :multiple="false"
        :allowEmpty="!!allowEmpty"
        placeholder="Convenio"
        selectedLabel=""
        selectLabel=""
        deselectLabel=""
        @input="notifyChange"></multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {mapGetters} from 'vuex';

    export default {
        name: "CommonAgreementSelector",
        components: {
            Multiselect
        },
        props: {
            value: Object,
            allowEmpty: Boolean,
            headquartersId: String
        },
        data: function () {
            return {
                commonAgreement: null
            }
        },
        created() {
            this.$store.dispatch('loadAgreements');
            this.commonAgreement = this.evaluateValue(this.value);
        },
        computed: {
            ...mapGetters([
                'commonAgreements',
                'commonAgreementsByHeadquarters'
            ]),
            agreements() {
                if (!!this.headquartersId) {
                    return this.commonAgreementsByHeadquarters(this.headquartersId);
                } else {
                    return this.commonAgreements
                }
            }
        },
        methods: {
            evaluateValue(value) {
                if (!!value && !!value.uuid) {
                    return this.findAgreementByUuid(value.uuid);
                } else {
                    return null;
                }
            },
            findAgreementByUuid(uuid) {
                if (!!this.headquartersId) {
                    return this.commonAgreementsByHeadquarters(this.headquartersId).find(agreement => (agreement.uuid === uuid));
                } else {
                    return this.commonAgreements.find(agreement => (agreement.uuid === uuid));
                }
            },
            notifyChange(agreement) {
                this.$emit('input', agreement);
            }
        },
        watch: {
            value: function () {
                this.commonAgreement = this.evaluateValue(this.value);
            },
            commonAgreements: function () {
                this.commonAgreement = this.evaluateValue(this.value);
            },
            headquartersId: function () {
                this.commonAgreement = this.evaluateValue(this.value);
            }
        }
    }
</script>

<style scoped>

</style>